export const FormMask = {
  NotSet: '',
  smsCode: '####',
  carChassisNumber: '######',
  carVinCode: 'NNNNNNNNNNNNNNNNN',
  carBodyNumber: 'NNNNNNNNNNNN',
  Tel: 'tel',
  TelEpam: '+7 (###) ###-##-##',
  BsoSeries: 'XXXXX',
  verificationCode: '####',
  BsoNumber: '#######',
  insuranceLetterNumber: '##############',
  CaseNumber: '##########',
  Inn: '############',
  DateDDMMYYYY: '##.##.####',
  DateYYYYMMDD: '####-##-##',
  SeriesNumberPolice: [
    /[AАBВCСEЕTТOОHНMМKКPР]/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  OsagoSeriesNumberPolice: [
    /[AАBВCСEЕTТOОHНMМKКPР]/,
    /[AАBВCСEЕTТOОHНMМKКPР]/,
    /[AАBВCСEЕTТOОHНMМKКPР]/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
  // Date = [
  //   /[0-3]/,
  //   /[0-9]/,
  //   '.',
  //   /[0-1]/,
  //   /[0-9]/,
  //   '.',
  //   /[0-2]/,
  //   /[0-9]/,
  //   /[0-9]/,
  //   /[0-9]/,
  // ],
  ZipCode: '######',
  PreviousRequestNumber:
    'X-#######################################################################################################################################################################################################',
  KaskoSeries: 'XXXXXXXXXX',
  DriverLicense: '##########',
  KaskoNumber: 'XXXXXXXXXXXXXXX',
  OsagoNumber: '##########',
  PassportSeries: '## ##',
  PassportNumber: '######',
  PassportSeriesNumber: '#### ######',
  DrivingLicenceSer: 'drivingLicenceSer',
  EnginePower: 'enginePower',
  RegistrationPlate: 'registrationPlate',
  VinCode: 'vinCode',
  BodyNumber: 'bodyNumber',
  BrokerAndAgent: 'broker',
  CountTaxRequests: '###',
}
